<template>
  <div class="step-pane fade-in">
    <el-form ref="postForm" :model="value" :rules="rules" label-position="top" class="custom-form">
      <el-form-item label="视频标题" prop="title">
        <el-input v-model="value.title" placeholder="给视频起个亮眼的名字吧" maxlength="50" show-word-limit />
      </el-form-item>

      <el-form-item label="视频简介" prop="description">
        <el-input v-model="value.description" type="textarea" :rows="5" placeholder="介绍一下你的视频吧..." maxlength="200" show-word-limit />
      </el-form-item>

      <el-form-item v-if="!isEdit" label="选择分区" prop="categoryId">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-select v-model="value.categoryPid" placeholder="一级分区" style="width: 100%;" @change="handlePCategoryChange">
              <el-option v-for="item in pCategoryList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-select v-model="value.categoryId" placeholder="二级分区" style="width: 100%;">
              <el-option v-for="item in subCategoryList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item v-if="!isEdit" label="标签设置" prop="tags">
        <el-select v-model="value.tags" multiple filterable allow-create default-first-option placeholder="输入标签后按回车添加" style="width: 100%;" class="tags-select">
          <el-option v-for="tag in recommendTags" :key="tag" :label="tag" :value="tag" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="!isEdit" label="可见权限">
        <el-radio-group v-model="value.scope" size="medium" class="custom-radio-group">
          <el-radio-button label="1">私有</el-radio-button>
          <el-radio-button label="2">公开</el-radio-button>
          <el-radio-button label="3">VIP可见</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <div class="step-actions">
      <el-button
        type="success"
        size="medium"
        class="submit-btn"
        :class="{'ml-auto': isSingle}"
        :loading="submitting"
        icon="el-icon-check"
        @click="submitForm"
      >
        {{ isEdit ? '保存修改' : '立即发布稿件' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { videoRegion } from '@/api/vod'

export default {
  name: 'StepFormInfo',
  props: {
    value: { type: Object, required: true },
    isEdit: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
    isSingle: { type: Boolean, default: false }
  },
  data() {
    return {
      pCategoryList: [],
      subCategoryList: [],
      categoryRawData: [],
      recommendTags: ['tnb'],
      rules: {
        title: [{ required: true, message: '请输入视频标题', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择完整的二级分区', trigger: 'change' }],
        tags: [{ type: 'array', required: true, message: '请至少添加一个标签', trigger: 'change' }]
      }
    }
  },
  watch: {
    categoryRawData(val) {
      if (val && val.length > 0 && this.value.categoryPid) {
        this.handlePCategoryChange(this.value.categoryPid, true)
      }
    }
  },
  created() {
    this.initCategoryData()
  },
  methods: {
    async initCategoryData() {
      const res = await videoRegion()
      if (res.code === 0) {
        this.categoryRawData = res.data
        this.pCategoryList = res.data.map(item => ({ label: item.label, value: item.value }))
      }
    },
    handlePCategoryChange(pid, isInit = false) {
      if (!isInit) { this.value.categoryId = null }
      if (!pid) { this.subCategoryList = []; return }
      const parent = this.categoryRawData.find(i => i.value === pid)
      this.subCategoryList = parent ? parent.children : []
    },
    submitForm() {
      this.$refs.postForm.validate((valid) => {
        if (valid) {
          this.$emit('submit')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.video-post-container {
  padding: 32px 20px;
  background-color: #f6f8fa;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  .steps-wrapper {
    width: 100%;
    max-width: 880px; // 限制表单总宽度，防止宽屏下横向拉伸过长导致视觉松散
    border: 1px solid #eaeefb;
    border-radius: 12px;
    box-shadow: 0 6px 16px -4px rgba(0, 0, 0, 0.04);
    padding: 12px;
  }

  .custom-steps {
    margin-bottom: 40px;
    ::v-deep .el-step__title {
      font-size: 14px;
      font-weight: 500;
    }
  }

  // 步骤内容切换区域
  .step-content-router {
    min-height: 320px;
  }

  // 淡入动效
  .fade-in {
    animation: fadeIn 0.35s ease-in-out;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  // 统一的下方操作栏
  .step-actions {
    margin-top: 36px;
    padding-top: 20px;
    border-top: 1px solid #f0f2f5;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.center {
      justify-content: center;
    }
  }
}

/* 封面上传样式优化 */
.cover-upload-wrapper {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  padding: 10px 0;

  .avatar-uploader {
    border: 2px dashed #e0e0e0;
    border-radius: 10px;
    cursor: pointer;
    overflow: hidden;
    width: 260px;
    height: 155px;
    background: #fafafa;
    transition: all 0.25s ease-in-out;
    flex-shrink: 0;

    &:hover {
      border-color: #409EFF;
      background: #f5f9ff;
    }
  }

  .uploader-placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #909399;

    .placeholder-icon { font-size: 26px; margin-bottom: 8px; }
    .placeholder-text { font-size: 13px; }
  }

  .cover-preview {
    position: relative;
    width: 100%;
    height: 100%;
    .avatar { width: 100%; height: 100%; object-fit: cover; }
    .cover-mask {
      position: absolute; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(29, 33, 41, 0.6); color: #fff;
      display: flex; flex-direction: column; justify-content: center; align-items: center;
      gap: 6px; font-size: 13px; opacity: 0; transition: opacity 0.2s ease;
    }
    &:hover .cover-mask { opacity: 1; }
  }

  .cover-info-text {
    flex: 1;

    .tip-title {
      font-size: 14px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      gap: 4px;
      i { color: #409EFF; }
    }
    .tip-item { font-size: 13px; color: #8c929e; margin: 6px 0; line-height: 1.6; }
  }
}

/* 表单精细化调整 */
.custom-form {
  ::v-deep .el-form-item__label {
    padding-bottom: 6px;
    font-weight: 500;
    color: #303133;
  }

  .custom-radio-group {
    width: 100%;
    display: flex;
    ::v-deep .el-radio-button {
      flex: 1;
      .el-radio-button__inner { width: 100%; text-align: center; }
    }
  }

  .tags-select {
    ::v-deep .el-select__tags { max-height: 80px; overflow-y: auto; }
  }
}

.ml-auto {
  margin-left: auto;
}
</style>
